module.exports = "<input [style.width]='width' [formControl]=\"valueControl\">\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/filter-input/filter-input.component.html
// module id = ../../../../../src/app/filter-input/filter-input.component.html
// module chunks = main